import { startCase } from 'lodash';
import { ScopeTreeBranchInterface, ScopeTreeItem } from '@/services/Scopes/Interfaces';
import { Treeview } from '@/views/interfaces/vuetify/treeview.interface';

export class ScopeTreeBranch implements ScopeTreeBranchInterface {
  public id: string;

  constructor(
    public name: string,
    public children: { [scope: string]: ScopeTreeItem } = {},
    public disabled: boolean = false,
  ) {
    this.id = String(Math.floor(Math.random() * Math.floor(5000)) + 5000);
  }

  public addChild(child: ScopeTreeItem): void {
    this.children[child.name] = child;
  }

  public hasChild(child: string): boolean {
    return Object.keys(this.children).indexOf(child) !== -1;
  }

  public getChild(child: string): ScopeTreeItem {
    return this.children[child];
  }

  public toTreeView(): Treeview {
    return {
      name: startCase(this.name.toLowerCase()),
      id: this.id,
      disabled: this.disabled,
      children: Object.keys(this.children).map((scope: string) => {
        return {
          id: this.children[scope].id,
          name: scope.split(':').map((piece: string) => startCase(piece.toLowerCase())).join(' '),
          disabled: this.children[scope].disabled,
        };
      }),
    };
  }
}
